import { render, staticRenderFns } from "./fieldworkBatch.vue?vue&type=template&id=5a36949e&scoped=true"
import script from "./fieldworkBatch.vue?vue&type=script&lang=js"
export * from "./fieldworkBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a36949e",
  null
  
)

export default component.exports